<template>
  <div>
    <v-row class="ma-0 mt-3 rounded-lg pa-4 white">
      <v-col cols="12" class="d-flex align-center">
        <h4 class="text-subheading-2 black--text font-weight-bold">
          <!-- {{ tripDetails.reference_number }} -->
          {{ orderModule.orderPlural }}
        </h4>
      </v-col>
      <v-col cols="3" class="mt-1 pb-0">
        <SelectField
          id="order_status"
          ref="operationOrderStatus"
          label="Select Order Status"
          :itemsList="orderStatus"
          itemText="label"
          class="mb-4"
          itemValue="value"
          v-model="selectedOrderStatus"
          :multiple="true"
          clearable
          @change="getOrderList()"
        >
        </SelectField>
      </v-col>
      <v-col cols="12" class="pt-1">
        <AgGridVue
          @grid-ready="gridReady"
          :grid-options="gridOptions"
          :column-defs="tableHeader"
          :default-col-def="defaultColDef"
          :context="context"
          :rowData="allOrderList"
          class="ag-theme-balham"
          style="width: 100%; height: calc(100vh - 395px)"
        >
        </AgGridVue>
      </v-col>
      <v-col cols="6" class="d-flex justify-start align-center pb-0">
        <PaginationCount :total="totalCount" />
      </v-col>
      <v-col cols="6" class="d-flex justify-end pb-0">
        <Pagination
          :pageNo="pageNo"
          :totalItems="totalCount"
          :pageSize="itemsPerPage"
          @itemsPerPageChange="itemsPerPageChange"
          @prevPage="prevPage"
          @nextPage="nextPage"
        />
      </v-col>
      <v-col class="d-none">
        <BaseDialog
          title="Order Details"
          v-model="openOrderListDialog"
          height="100vh"
          width="90vw"
          cardTextClass="pa-0 ma-0"
        >
          <template #information>
            <div class="background_color h-100">
              <OrderDetails ref="orderList" :id="selectedOrder.id" />
            </div>
          </template>
        </BaseDialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import { AgGridVue } from "ag-grid-vue";
import { orderModule } from "@/utils/moduleMapping";
import PaginationCount from "@/components/BaseComponents/PaginationCount.vue";
import Pagination from "@/components/BaseComponents/Pagination.vue";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import OrderDetails from "@/components/ModuleBasedComponents/Order/OrderDetails.vue";
import OperationsOrderButton from "@/components/Button/OperationsOrderButton.vue";
import OperationsOrderStatusChip from "@/components/Button/OperationsOrderStatusChip.vue";

export default {
  props: {
    filters: {
      type: Object,
      default: {},
    },
  },
  components: {
    AgGridVue,
    PaginationCount,
    Pagination,
    BaseDialog,
    OrderDetails,
    OperationsOrderButton,
    OperationsOrderStatusChip,
  },
  data() {
    return {
      orderModule,
      orderStatus: this.$globalConstant.orderStatus,
      searchOrders: null,
      selectedOrderStatus: [],
      itemsPerPage: 20,

      defaultColDef: {
        lockPosition: true,
        flex: 1,
        resizable: true,
        sortable: true,
        autoHeight: true,
        cellStyle: {
          "text-overflow": "ellipsis",
          "white-space": "nowrap",
          overflow: "hidden",
          display: "block",
        },
      },
      columnDefs: [
        {
          headerName: "Action",
          field: "action",
          cellRenderer: "OperationsOrderButton",
          width: 100,
          pinned: "left",
        },
        {
          headerName: "Order Reference",
          field: "reference_number",
          sortable: true,
          width: 100,
          pinned: "left",
        },
        {
          headerName: "Status",
          field: "status",
          cellRenderer: "OperationsOrderStatusChip",
          minWidth: 200,
        },
        {
          headerName: "Order Type",
          field: "order_type",
        },
        {
          headerName: "Address",
          field: "address",
          minWidth: 275,
          tooltipField: "address",
        },
        // {
        //   headerName: "Driver Name",
        //   field: "driver",
        // },
        // {
        //   headerName: "Contact No",
        //   field: "contact_number",
        // },
        {
          headerName: "Customer",
          field: "customer_name",
        },
        {
          headerName: "Branch",
          field: "branch_name",
        },
        {
          headerName: "Updated On",
          field: "updated_on",
          sortable: true,
        },
      ],
      gridOptions: {
        onGridSizeChanged: () => {
          // this.autoSizeAll();
        },
        tooltipShowDelay: 0,
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
      },
      totalItems: 0,
      pageNo: 1,
      totalCount: 0,
      allOrderList: [],
      openOrderListDialog: false,
      selectedOrderSegment: null,
      selectedOrder: {},
    };
  },
  computed: {
    tableHeader() {
      if (this.$helper.isCompanyHasItems()) {
        this.columnDefs.splice(3, 0, {
          headerName: "Items",
          field: "no_of_items",
          sortable: true,
        });
      }
      return this.columnDefs;
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.itemsPerPage);
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    getOrderDetails(data) {
      this.selectedOrder = data;
      this.selectedOrderSegment = data.segment;
      this.openOrderListDialog = true;
      setTimeout(() => {
        this.$refs.orderList.getOrderData(data.id);
      }, 1000);

      // this.openOrderListDialog = false;
      // if (this.$refs.viewTripOrderDetails) {
      //   this.showTripOrderDetails = true;
      //   this.$refs.viewTripOrderDetails.getOrderDetails(id);
      //   this.$refs.viewTripOrderDetails.getOrderLogs(id);
      // } else {
      //   this.showOrderDetails = true;
      //   this.$refs.orderDetails.getOrderDetails(id);
      //   this.$refs.orderDetails.getOrderLogs(id);
      // }
    },

    clearOrderSearch() {
      this.searchOrders = null;
      this.itemsPerPageChange(10);
    },
    nextPage() {
      this.pageNo++;
      this.getOrderList();
    },
    prevPage() {
      this.pageNo--;
      this.getOrderList();
    },
    itemsPerPageChange(value) {
      this.pageNo = 1;
      this.itemsPerPage = value;
      this.getOrderList();
    },
    autoSizeAll() {
      let allColumnIds = [];
      this.gridOptions.columnApi.getColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
    },
    gridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.autoSizeAll();
    },

    getOrderList(params = {}) {
      params = {
        ...params,
        ...this.filters,
        limit: this.itemsPerPage,
        offset: this.offset,
      };
      if (this.searchOrders) {
        params.search = this.searchOrders;
      }
      if (this.selectedTripId) {
        params.trip = this.selectedTripId;
      }
      if (this.selectedProjects && this.selectedProjects.length > 0) {
        params.project = this.selectedProjects.join(",");
      }
      if (this.selectedOrderStatus && this.selectedOrderStatus.length > 0) {
        params.status = this.selectedOrderStatus.join(",");
      }
      bus.$emit("showLoader", true);
      this.$api.operation
        .getOperationOrderList(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.allOrderList = res.data;
          this.totalCount = res.count;
        })
        .catch((err) => {
          bus.$emit("showLoader", false);
          console.error(err);
          this.allOrderList = [];
        });
    },
  },
};
</script>

<style></style>
